export default __webpack_public_path__ + "static/media/banner-acidentes-pessoais-bem-estar.2e3ff6b9.png";